import { createContext, useContext, type ReactNode } from "react";
import { useIsPresent } from "framer-motion";
import { createPortal } from "react-dom";

/** Local to one focused viewer: descendants can reuse its existing header. */
export const FocusedHeaderActionsContext = createContext<HTMLElement | null>(null);

export function FocusedHeaderActions({ children }: { children: ReactNode }) {
  const host = useContext(FocusedHeaderActionsContext);
  const isPresent = useIsPresent();
  if (!isPresent) return null; // Exiting focus views must not share the new header.
  return host ? createPortal(children, host) : children;
}

export function useFocusedHeaderHost() {
  return useContext(FocusedHeaderActionsContext);
}
